import { queryOptions, useQuery } from '@tanstack/react-query';

import APIStage from '@api/graphqlStageOld';
import { configValuesKeys } from '@api/enums/configValues.enum';
import { withSsrCache } from '../../ssrCache';

/**
 * Значения конфига сайта (`config.value_list`): ключи карт и DaData, ссылки
 * на оферты, суммы бонусов за приглашение и т.п. Меняются крайне редко.
 *
 * ЭТАП 2 (SSR): раньше единственным их держателем был `ConfigStore` —
 * mobx-стор, который наполняется методом `wakeUp()` из эффекта, то есть
 * ТОЛЬКО на клиенте. Страницы, которые гейтят рендер на значении из
 * конфига (`/oferta-courier`: `if (!configStore.data.courier_oferta)
 * return <LoadingPage/>`), на сервере отдавали пустоту.
 *
 * Здесь тот же запрос, но через react-query: его можно префетчить,
 * и данные доступны уже в первом рендере. Стор при этом не трогаем — он
 * продолжает жить своей жизнью и наполняться на клиенте; когда-нибудь его
 * тоже стоит перевести на этот ключ, чтобы запрос был ровно один.
 */
const CONFIG_VALUES_STALE_TIME = 10 * 60 * 1000;
const CONFIG_VALUES_GC_TIME = 15 * 60 * 1000;

export const configValuesQueryOptions = () =>
  withSsrCache(
    queryOptions({
      queryKey: ['configValues'],
      queryFn: async () => await APIStage.configValueList(configValuesKeys),
      staleTime: CONFIG_VALUES_STALE_TIME,
      gcTime: CONFIG_VALUES_GC_TIME
    })
  );

export const useConfigValuesQuery = () => useQuery(configValuesQueryOptions());
